import { useQuery } from "@apollo/client";
import { getTranscriptEntitiesQuery } from "../modules/queries";
import { getOrganizationId } from "modules/CommonSelectors";
import _ from "lodash";
import { useMemo } from "react";

const EMPTY_ARRAY = [];

const useTranscriptEntities = () => {
  const { data, networkStatus } = useQuery(getTranscriptEntitiesQuery, {
    fetchPolicy: "cache-and-network",
    variables: { id: getOrganizationId() },
    context: {
      useHttpLink: true,
    },
  });

  const [gradingPeriods, customGradingPeriods] = useMemo(() => {
    return _.chain(data)
      .get("node.transcriptGradingPeriods", EMPTY_ARRAY)
      .partition(period => !_.get(period, "isCustom", false))
      .value();
  }, [data]);

  const [grades, customGrades] = useMemo(() => {
    return _.chain(data)
      .get("node.transcriptGrades", EMPTY_ARRAY)
      .partition(grade => !_.get(grade, "isCustom", false))
      .value();
  }, [data]);

  const academicYears = useMemo(() => {
    return _.get(data, "node.transcriptAcademicYears", EMPTY_ARRAY);
  }, [data]);

  const schools = useMemo(() => {
    return _.get(data, "node.transcriptSchools", EMPTY_ARRAY);
  }, [data]);

  const sortedCustomGrades = useMemo(() => {
    return _.orderBy(customGrades, ["displaySequence"], ["asc"]);
  }, [customGrades]);

  return {
    isLoading: _.isEmpty(data) && _.includes([1, 2], networkStatus),
    academicYears,
    gradingPeriods,
    customGradingPeriods,
    schools,
    grades,
    customGrades: sortedCustomGrades,
  };
};

export default useTranscriptEntities;
